import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/brand";

/**
 * Refined, integrated WhatsApp float — cream pill with green icon circle.
 * No aggressive pulse; subtle lift on hover. Reads as part of the design.
 */
export const WhatsAppFloat = ({ theme = "tarq", label = "Reservar" }) => {
  const message =
    theme === "bbq"
      ? "Olá! Gostaria de fazer uma reserva no BBQ Assador."
      : "Olá! Gostaria de fazer uma reserva no Tarquínio Beach Club.";

  const isBbq = theme === "bbq";
  const pillBg = isBbq ? "bg-[#1A1510]/95 border-[#E85A1F]/30" : "bg-white/96 border-[#0F2A44]/12";
  const ink = isBbq ? "text-[#F5EDD9]" : "text-[#0F2A44]";
  const iconBg = isBbq ? "bg-[#E85A1F]" : "bg-[#E88B4F]";
  const fontClass = isBbq ? "font-sans-bbq" : "font-sans-tarq";

  return (
    <a
      data-testid="whatsapp-float"
      href={waLink(message)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Reservar via WhatsApp"
      className={`fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-50 group inline-flex items-center gap-3 rounded-full ${pillBg} backdrop-blur-xl pl-2 pr-5 py-2 sm:pl-2 sm:pr-6 sm:py-2 border shadow-[0_16px_40px_-14px_rgba(0,0,0,0.22)] transition-all duration-500 hover:-translate-y-0.5 wa-pulse-3s`}
    >
      <span className={`flex items-center justify-center h-9 w-9 sm:h-10 sm:w-10 rounded-full ${iconBg} text-white transition-transform duration-500 group-hover:scale-110`}>
        <MessageCircle className="h-4 w-4 sm:h-[18px] sm:w-[18px]" strokeWidth={2} />
      </span>
      <span className={`hidden sm:inline ${ink} ${fontClass} text-[10px] tracking-[0.32em] uppercase`}>
        {label} · WhatsApp
      </span>
      <span className={`sm:hidden ${ink} ${fontClass} text-[11px] tracking-[0.28em] uppercase pr-1`}>
        WhatsApp
      </span>
    </a>
  );
};

export default WhatsAppFloat;
